export default {
  get: {
    method: 'post',
    url: '/activities/MODULE'
  }
}
